/**
 * SCORM player sessions — the widgetless corner of lib/api: one POST to
 * mint an enrollment-bound session, whose player URL then runs cookie-free
 * on signed tokens inside the frame.
 */
import api from '../lib/api';
import { ENV } from '../config/env';

export interface ScormSession {
  token: string;
  player_url: string;
  version: string;
}

export async function createScormSession(
  moduleId: string,
  opts: { assignmentId?: string; preview?: boolean }
): Promise<ScormSession> {
  const res = await api.post<{ data: ScormSession }>(
    `/scorm/${moduleId}/session`,
    {
      assignment_id: opts.assignmentId,
      preview: opts.preview ?? false,
    },
    // First launch extracts the package server-side — big zips take
    // longer than the global 10s timeout (later launches are instant).
    { timeout: 120_000 }
  );
  return res.data.data;
}

/** Absolute player URL (the API origin, not the app origin). */
export function absolutePlayerUrl(playerUrl: string): string {
  const origin = ENV.api.baseURL.replace(/\/api\/v1\/?$/, '');
  return `${origin}${playerUrl}`;
}
